import { useClasser } from "@code-hike/classer";
import * as React from "react";
export const SandpackStack = ({ children, customStyle, }) => {
    const c = useClasser("sp");
    return (React.createElement("div", { className: c("stack"), style: customStyle }, children));
};
//# sourceMappingURL=Stack.js.map